var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sensor-chart-renderer"},[_c('apexchart',{key:_vm.chartKey,ref:"apexChart",attrs:{"width":"100%","type":"line","height":"300px","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }